<template>
  <div class="row pushfooter">
    <div class="col-10 col-sm-12 row">
      <div class="col--mid-marg bg--black pushfooter__item">
        <p class="title-h2">
          À<br> <span>l’affiche</span>
        </p>
        <button-arrow link="/agenda" css="button--transp-white">
          En ce moment<br> au Grand Théâtre
        </button-arrow>
      </div>
      <div class="col--mid-marg bg--darkgrey pushfooter__item">
        <p class="title-h2">
          découvrir la<br>
          <span>programmation</span>
        </p>
        <button-arrow link="/agenda" css="button--transp-blue desktop">
          découvrir<br> la programmation de la saison
        </button-arrow>
        <button-arrow link="/agenda" css="button--transp-blue button--3lines mobile">
          découvrir<br> la programmation <br>de la saison
        </button-arrow>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.pushfooter{
  margin-bottom: -$col-size;
  z-index: 10;
  &__item{
    position: relative;
    padding: 7.5%;
    .title-h2{
      margin-bottom: 3rem;
      font-size:5rem;
      color: #78909c;
      span{
        color: white;
      }
      @media #{$bp-sm}{
        font-size: 3.6rem;
      }
    }
    .button{
      margin-top: 3rem;
    }
  }
}

</style>

<script>
import ButtonArrow from '../components/ButtonArrow.vue';
export default {
  components: {
    ButtonArrow,
  },
};
</script>
